module.exports = __webpack_public_path__ + "static/media/logo-semosis.7f7b5295.svg";